import { defineComponent as _defineComponent } from 'vue'
import { EstateContacts } from "@/types/CustomerLotDetails";
  

  interface Props {
    estateContacts: EstateContacts;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerLotEstateContacts',
  props: {
    estateContacts: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props, get EstateContacts() { return EstateContacts } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})